import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';

export enum ToggleBarIconVariant {
  DEFAULT = 'default',
}

export interface IToggleBarIconProps extends IConDefaultType {
  variant?: ToggleBarIconVariant;
}

function ToggleBarIcon({
  color,
  className,
  size = 26,
  rotate,
  flip,
  variant = ToggleBarIconVariant.DEFAULT,
  style,
}: IToggleBarIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === ToggleBarIconVariant.DEFAULT && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="124"
          height="4"
          viewBox="0 0 124 4"
          fill={color || theme.color.icon.icon_4}
        >
          <path
            d="M1.78516 2H121.785"
            stroke={color || theme.color.icon.icon_4}
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )}
    </i>
  );
}

export default ToggleBarIcon;
